// extracted by mini-css-extract-plugin
export default {"root":"skeleton-item_root__aySe7","placeHolderShimmer":"skeleton-item_placeHolderShimmer__jfDuz"};